import React, { FC, memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { unescape } from "lodash";
import { Tooltip } from "@evergis/ui";

import { LegendToggler } from "../../../LayerList/styled";
import { useToggle } from "../../../../hooks/useToggle";

type TextTrimProps = {
  maxLength?: number;
  expandable?: boolean;
  lineBreak?: string;
  children?: string | number;
};

export const TextTrim: FC<TextTrimProps> = memo(({ maxLength, expandable, lineBreak, children }) => {
  const { t } = useTranslation("featureCard");
  const [expanded, toggleExpanded] = useToggle();
  const text = children?.toString();

  const formatValue = useCallback(
    (value: string) => {
      if (!lineBreak) return value;

      return <div dangerouslySetInnerHTML={{ __html: unescape(value).split(lineBreak).join("<br />") }} />;
    },
    [lineBreak],
  );

  if (!text?.length || !maxLength || text.length <= maxLength) return <>{formatValue(text)}</>;

  const substring = `${text.substring(0, maxLength)}...`;

  if (expandable) {
    return (
      <>
        {formatValue(expanded ? text : substring)}
        <LegendToggler toggled={expanded} onClick={toggleExpanded}>
          {expanded ? t("hide") : t("more")}
        </LegendToggler>
      </>
    );
  }

  return (
    <Tooltip placement={"top"} arrow content={text}>
      {ref => <div ref={ref}>{formatValue(substring)}</div>}
    </Tooltip>
  );
});
